import { render } from "./BaseChip.vue?vue&type=template&id=06776156"
import script from "./BaseChip.vue?vue&type=script&lang=js"
export * from "./BaseChip.vue?vue&type=script&lang=js"

import "./BaseChip.vue?vue&type=style&index=0&id=06776156&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__